module.exports = __webpack_public_path__ + "img/室外wifi机 导航Z60.1f396b01.jpg";